import { default as accountKVUlIIT7oTMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/account.vue?macro=true";
import { default as _91project_id_93CJ3J18ZVxNMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/blink/[project_id].vue?macro=true";
import { default as calendarR2IVZHpJAfMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/calendar.vue?macro=true";
import { default as claims0NUyuetT9Meta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/claim.vue?macro=true";
import { default as indexF42BywbM6LMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/index.vue?macro=true";
import { default as inoPxFWIC1sT8Meta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/ino.vue?macro=true";
import { default as kwai_45partial_45migrateN7M5CbvqRqMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/kwai-partial-migrate.vue?macro=true";
import { default as otcAFF6tgjKzxMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/otc.vue?macro=true";
import { default as private_45sale_45passiQVRAJPj30Meta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/private-sale-pass.vue?macro=true";
import { default as _91project_id_93XCgSMWooKNMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/private/[project_id].vue?macro=true";
import { default as _91project_id_93iX3hl4VeHoMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/project/[project_id].vue?macro=true";
import { default as stakeZjpLhnLj6vMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/stake.vue?macro=true";
import { default as tg_45link4la3DJVa0IMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/tg-link.vue?macro=true";
import { default as faqDOlaQUcxhAMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/faq.vue?macro=true";
import { default as giftGraviFVVD0Meta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/gift.vue?macro=true";
import { default as hall_45of_45fames3BM5V4HgGMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/hall-of-fame.vue?macro=true";
import { default as index_copy0n3cXew3PUMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/index_copy.vue?macro=true";
import { default as indexGBLDAWG5A2Meta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/index.vue?macro=true";
import { default as privacyQ3qDKHXbEcMeta } from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/privacy.vue?macro=true";
export default [
  {
    name: "account",
    path: "/app/account",
    meta: accountKVUlIIT7oTMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/account.vue")
  },
  {
    name: "blink",
    path: "/app/blink/:project_id()",
    meta: _91project_id_93CJ3J18ZVxNMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/blink/[project_id].vue")
  },
  {
    name: "calendar",
    path: "/app/calendar",
    meta: calendarR2IVZHpJAfMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/calendar.vue")
  },
  {
    name: "claim",
    path: "/app/claim",
    meta: claims0NUyuetT9Meta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/claim.vue")
  },
  {
    name: "app",
    path: "/app",
    meta: indexF42BywbM6LMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/index.vue")
  },
  {
    name: "ino",
    path: "/app/ino",
    meta: inoPxFWIC1sT8Meta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/ino.vue")
  },
  {
    name: "kwai-partial-migrate",
    path: "/app/kwai-partial-migrate",
    meta: kwai_45partial_45migrateN7M5CbvqRqMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/kwai-partial-migrate.vue")
  },
  {
    name: "otc",
    path: "/app/otc",
    meta: otcAFF6tgjKzxMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/otc.vue")
  },
  {
    name: "privateSalePass",
    path: "/app/private-sale-pass",
    meta: private_45sale_45passiQVRAJPj30Meta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/private-sale-pass.vue")
  },
  {
    name: "private",
    path: "/app/private/:project_id()",
    meta: _91project_id_93XCgSMWooKNMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/private/[project_id].vue")
  },
  {
    name: "project",
    path: "/app/project/:project_id()",
    meta: _91project_id_93iX3hl4VeHoMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/project/[project_id].vue")
  },
  {
    name: "stake",
    path: "/app/stake",
    meta: stakeZjpLhnLj6vMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/stake.vue")
  },
  {
    name: "app-tg-link",
    path: "/app/tg-link",
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/app/tg-link.vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: faqDOlaQUcxhAMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/faq.vue")
  },
  {
    name: "gift",
    path: "/gift",
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/gift.vue")
  },
  {
    name: "hall-of-fame",
    path: "/hall-of-fame",
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/hall-of-fame.vue")
  },
  {
    name: "home",
    path: "/index_copy",
    meta: index_copy0n3cXew3PUMeta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/index_copy.vue")
  },
  {
    name: "home",
    path: "/",
    meta: indexGBLDAWG5A2Meta || {},
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/pages/privacy.vue")
  }
]